import { getUsers } from "../../utils/api";
import { showLoading, hideLoading } from "react-redux-loading";
import { saveQuestionAnswer } from "./questionActions";
import { Action } from "redux";
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const LOAD_USERS = "LOAD_USERS";
export const UPDATE_ANSWERED = "UPDATE_ANSWERED";
export const UPDATE_QUESTIONS = "UPDATE_QUESTIONS";

export const userLogin = (user: any) => {
  return {
    type: LOG_IN,
    loggedUser: user,
  };
};

export const userLogout = () => {
  return {
    type: LOG_OUT,
    loggedUser: {},
  };
};

export const loadUsers = (users: any[]) => {
  return {
    type: LOAD_USERS,
    users: users,
  };
};

export const getAllUsers = () => {
  return (dispatch: (arg0: Action<any>) => void, getState: () => { (): any; new(): any; userReducer: { (): any; new(): any; users: { (): any; new(): any; length: number; }; }; }) => {
    if (getState().userReducer.users.length > 0) return;
    dispatch(showLoading());
    getUsers()
      .then((data:any) => {
        dispatch(hideLoading());
        var result = Object.keys(data).map((key) => data[key]);
        dispatch(loadUsers(result));
      })
      .catch(() => {
        dispatch(hideLoading());
        alert("There was an error 'getAllUsers'. Try again");
      });
  };
};

export const updateAnswered = (info: any) => {
  return {
    type: UPDATE_ANSWERED,
    info,
  };
};

export const UpdateAnswered = (info: any) => {
  return (dispatch: (info: any) => void) => {
    dispatch(updateAnswered(info));
    dispatch(saveQuestionAnswer(info));
  };
};

export const updateQuestions = (info: any) => {
  return {
    type: UPDATE_QUESTIONS,
    info,
  };
};
